import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader'
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js'
import { DDSLoader } from 'three/examples/jsm/loaders/DDSLoader.js'


const loadGLTF = async function(filePath){
  // Instantiate a loader
  const loader = new GLTFLoader();

  return new Promise((resolve, reject)=>{
    loader
      .load(filePath, // onScucess
        (gltf)=>{
          resolve(gltf);
        }, 
        null,         // onProgress
        (error)=>{    // onError
          reject(error);
        });
  });
}

const loadRGBE = async function(dataType, filePath){
  return new Promise((resolve, reject)=>{
    new RGBELoader()
      .setDataType(dataType)
      .load(filePath, // onSuccess
        (texture)=>{
          resolve(texture);
        }, 
        null,         // onProgress
        (error)=>{    // onError
          reject(error);
        });
  });
}

const loadFBX = async function(filePath){
  return new Promise((resolve, reject)=>{
    new FBXLoader()
      .load(filePath, // onScucess
        (fbx)=>{
          resolve(fbx);
        }, 
        null,         // onProgress
        (error)=>{    // onError
          reject(error);
        });
  });
}

const loadTexture = async function(filePath){
  return new Promise((resolve, reject)=>{
    new THREE.TextureLoader().load(filePath, 
      (texture)=>{
        resolve(texture);
      },
      null,
      (error)=>{
        reject(error);
      });
  })
}

const loadDDS = async function(filePath){
  return new Promise((resolve, reject)=>{
    new DDSLoader().load(filePath,
      (texture)=>{
        resolve(texture);
      },
      null,
      (error)=>{
        reject(error);
      });
  });
}

const loadCubeMap = async function(filePath, format){
  const urls = [
    filePath + 'posx' + format, filePath + 'negx' + format,
    filePath + 'posy' + format, filePath + 'negy' + format,
    filePath + 'posz' + format, filePath + 'negz' + format
  ];
  return new Promise((resolve, reject)=>{
    new THREE.CubeTextureLoader().load(urls, 
        (texture)=>{
          resolve(texture);
        }, 
        null,         // onProgress
        (error)=>{    // onError
          reject(error);
        });
    });
}

const loadFile = async function(filePath){
  return new Promise((resolve, reject)=>{
    new THREE.FileLoader().load(filePath,
      (file)=>{
        resolve(file);
      },
      null,
      (error)=>{
        reject(error);
      });
  })
}

export {loadGLTF, loadRGBE, loadFBX, loadCubeMap, loadTexture, loadFile, loadDDS};
